import create from 'zustand'
import {
  DutyFilters,
  DutyOrder,
  DutyOrderField,
  Exact,
  InputMaybe,
  OrderDirection,
  Pagination,
} from 'generated/graphql'
import { PAGE_SIZE } from '@app.feature/coverletter/coverletter.write/module/constant'

const initialVariables = {
  orderBy: {
    field: DutyOrderField.SELF_INTRODUCTION_COUNT,
    direction: OrderDirection.DESC,
  },
  filterBy: {
    hasQuestionTemplate: true,
    ignoreEndedActivity: true,
  },
  pagination: {
    page: 1,
    pageSize: PAGE_SIZE,
  },
}

type Variables =
  | Exact<{
      orderBy?: InputMaybe<DutyOrder> | undefined
      filterBy?: InputMaybe<DutyFilters> | undefined
      pagination?: InputMaybe<Pagination> | undefined
    }>
  | undefined

type DutyModalStoreType = {
  closeModal: () => void
  setCloseModal: (item?: () => void) => void
  variables: Variables
  setVariables: (variables?: Variables) => void
  resetVariables: () => void
}

export const useDutyModalStore = create<DutyModalStoreType>((set) => ({
  closeModal: () => {},
  setCloseModal: (closeModal) => {
    set((store) => ({
      ...store,
      closeModal,
    }))
  },
  variables: initialVariables,
  setVariables: (variables) => {
    set((store) => ({
      ...store,
      variables,
    }))
  },
  resetVariables: () => {
    set((store) => ({
      ...store,
      variables: initialVariables,
    }))
  },
}))
